import reportsApi from "@/api/reports";
import moment from "moment";

// initial state
const state = {};

const getters = {};

const actions = {
  getTimeclockAllLocations({ commit }, params) {
    return new Promise((resolve, reject) => {
      reportsApi.getTimeclockAllLocations(
        params,
        (locations) => {
          resolve(locations);
        },
        (error) => {
          reject(error);
        },
      );
    });
  },

  getTimeclockLocations({ commit }, params) {
    return new Promise((resolve, reject) => {
      reportsApi.getTimeclockLocations(
        params,
        (locations) => {
          resolve(locations);
        },
        (error) => {
          reject(error);
        },
      );
    });
  },

  getCertificationsReport({ commit }) {
    return new Promise((resolve, reject) => {
      reportsApi.getCertificationsReport(
        {},
        (report) => {
          resolve(report);
        },
        (error) => {
          reject(error);
        },
      );
    });
  },

  getPayrollReport({ commit }, params) {
    return new Promise((resolve, reject) => {
      reportsApi.getPayrollReport(
        params,
        (report) => {
          resolve(report);
        },
        (error) => {
          reject(error);
        },
      );
    });
  },

  getBillingReport({ commit }, params) {
    return new Promise((resolve, reject) => {
      reportsApi.getBillingReport(
        params,
        (report) => {
          resolve(report);
        },
        (error) => {
          reject(error);
        },
      );
    });
  },

  getClientFulfillmentReport({ commit }, params) {
    return new Promise((resolve, reject) => {
      reportsApi.getClientFulfillmentReport(
        params,
        (report) => {
          resolve(report);
        },
        (error) => {
          reject(error);
        },
      );
    });
  },

  getClientLocationFulfillmentReport({ commit }, params) {
    return new Promise((resolve, reject) => {
      reportsApi.getClientLocationFulfillmentReport(
        params,
        (report) => {
          resolve(report);
        },
        (error) => {
          reject(error);
        },
      );
    });
  },

  getEmployeeShiftCountReport({ commit }, params) {
    return new Promise((resolve, reject) => {
      reportsApi.getEmployeeShiftCountReport(
        params,
        (report) => {
          resolve(report);
        },
        (error) => {
          reject(error);
        },
      );
    });
  },

  getEmployeeHoursAtLocation({ commit }, params) {
    return new Promise((resolve, reject) => {
      reportsApi.getEmployeeHoursAtLocation(
        params,
        (report) => {
          resolve(report);
        },
        (error) => {
          reject(error);
        },
      );
    });
  },

  getClientFulfillmentReport({ commit }, params) {
    return new Promise((resolve, reject) => {
      reportsApi.getClientFulfillmentReport(
        params,
        (report) => {
          resolve(report);
        },
        (error) => {
          reject(error);
        },
      );
    });
  },

  getManagerFulfillmentReport({ commit }, params) {
    return new Promise((resolve, reject) => {
      reportsApi.getManagerFulfillmentReport(
        params,
        (report) => {
          resolve(report);
        },
        (error) => {
          reject(error);
        },
      );
    });
  },

  getCurrentlyWorking({ commit }, params) {
    return new Promise((resolve, reject) => {
      reportsApi.getCurrentlyWorking(
        params,
        (shifts) => {
          resolve(shifts);
        },
        (error) => {
          reject(error);
        },
      );
    });
  },

  getContactReport({ commit }, params) {
    return new Promise((resolve, reject) => {
      reportsApi.getContactReport(
        params,
        (users) => {
          resolve(users);
        },
        (error) => {
          reject(error);
        },
      );
    });
  },

  getTimeclockSingleLocation({ commit }, params) {
    return new Promise((resolve, reject) => {
      reportsApi.getTimeclockSingleLocation(
        params,
        (shifts) => {
          resolve(shifts);
        },
        (error) => {
          reject(error);
        },
      );
    });
  },

  getClientTimeOrdered({ commit }, params) {
    return new Promise((resolve, reject) => {
      reportsApi.getClientTimeOrdered(
        params,
        (stats) => {
          resolve(stats);
        },
        (error) => {
          reject(error);
        },
      );
    });
  },

  getAllTimeOrdered({ commit }, params) {
    return new Promise((resolve, reject) => {
      reportsApi.getAllTimeOrdered(
        params,
        (stats) => {
          resolve(stats);
        },
        (error) => {
          reject(error);
        },
      );
    });
  },

  getShiftCancellations({ commit }, params) {
    return new Promise((resolve, reject) => {
      reportsApi.getShiftCancellations(
        params,
        (cancels) => {
          resolve(cancels);
        },
        (error) => {
          reject(error);
        },
      );
    });
  },

  getBirthdaysAnniversaries({ commit }, params) {
    return new Promise((resolve, reject) => {
      reportsApi.getBirthdaysAnniversaries(
        params,
        (cancels) => {
          resolve(cancels);
        },
        (error) => {
          reject(error);
        },
      );
    });
  },
};

const mutations = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
